import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-result-details',
  templateUrl: './result-details.component.html',
  styleUrls: ['./result-details.component.scss'],
})
export class ResultDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
